import React from 'react'
import classNames from 'classnames'

import style from './style.module.css'

type Props = React.HTMLAttributes<HTMLImageElement>

function PetPhoto({ className, ...rest }: Props) {
  return (
    <div className={classNames(style.wrapper, className)}>
      <img {...rest} />
    </div>
  )
}

export default PetPhoto
